import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showUpdate, remove, setPaginaAtual } from './identificadorTelegramActions';
import SPButton from '../common/form/spButton';
import PermissaoUsuario from '../auth/permissao';

import ReactTableGT2A from '../common/grid/gridReactTable';
import swal from 'sweetalert2';

class IdentificadorTelegramList extends Component {

    constructor(props) {
        super(props);

        this.removerIdentificador = this.removerIdentificador.bind(this);
    }

    handlePageChange = (page) => {
        this.props.setPaginaAtual(page);
    };

    removerIdentificador(data) {
        swal({
            title: 'Deseja realmente excluir?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: 'primary',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            allowOutsideClick: 'false'
        }).then((result) => {
            if (result.value) {
                this.props.remove(data);
            }
        });
    }

    render() {

        const identificadoresTelegram = this.props.list || [];
        const paginaAtual = this.props.paginaAtual;

        const columns = [
            {
                Header: 'Ações',
                Cell: row => (
                    <div>
                        <PermissaoUsuario tela="CadIdentificadorTelegram" condicao={true}>
                            <SPButton type='button' className='warning btn-sm' icon='pencil-alt' data-title='Alterar' onClick={() => this.props.showUpdate(row.original)} />
                            <SPButton type='button' className='danger btn-sm' icon='trash-alt' data-title='Excluir' onClick={() => this.removerIdentificador(row.original)} />
                        </PermissaoUsuario>
                        <PermissaoUsuario tela="CadIdentificadorTelegram" condicao={false}>
                            <SPButton type='button' className='warning btn-sm' icon='pencil-alt' disabled="disabled" />
                            <SPButton type='button' className='danger btn-sm' icon='trash-alt' disabled="disabled" />
                        </PermissaoUsuario>
                    </div>
                ),
                className: 'column_icon',
                width: 90,
                resizable: true,
                Filter: () => <div className='rt-th'><span >Filtrar</span></div>
            },
            {
                Header: 'Chat ID',
                accessor: 'id_chat', 
                width: 150,
                filterable: true,
                resizable: true,
                className: 'column_grid column_center',
            },
            {
                Header: 'Descrição',
                accessor: 'descricao',
                className: 'column_grid',
                filterable: true,
                resizable: true,
            }
        ];

        return (

            <ReactTableGT2A
                data={identificadoresTelegram}
                columns={columns}
                className='-striped -highlight'
                defaultPageSize={15}
                onPageChange={this.handlePageChange} 
                page={paginaAtual} 
            />
        )
    }
}

const mapStateToProps = state => ({ 
    list: state.identificadorTelegramCad.list,
    paginaAtual: state.identificadorTelegramCad.paginaAtual
 })
const mapDispatchToProps = dispatch => bindActionCreators({ showUpdate, remove,setPaginaAtual }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(IdentificadorTelegramList)
